export type SpecAttribute = {
  key: string
  value: string
}

function normalizeKey(key: string): string {
  return key.trim().toLowerCase()
}

/**
 * Display rows for the product specs table: parent attributes plus the
 * currently selected variant. Selected-variant values replace the same
 * normalized key; variant-only keys are appended.
 */
export function mergeProductSpecAttributes(
  parent: SpecAttribute[] | null | undefined,
  selectedVariantAttrs: SpecAttribute[] | null | undefined,
): SpecAttribute[] {
  const byKey = new Map<string, SpecAttribute>()

  for (const row of parent ?? []) {
    if (!row || typeof row !== 'object') continue
    const key = String(row.key ?? '').trim()
    const value = String(row.value ?? '').trim()
    if (!key || !value) continue
    byKey.set(normalizeKey(key), { key, value })
  }

  for (const row of selectedVariantAttrs ?? []) {
    if (!row || typeof row !== 'object') continue
    const key = String(row.key ?? '').trim()
    const value = String(row.value ?? '').trim()
    if (!key || !value) continue
    byKey.set(normalizeKey(key), { key, value })
  }

  return [...byKey.values()]
}
